import Webview from '../native/visible/Webview'
import SingleOfferTemplate from "./SingleOfferTemplate";


class H5VideoTemplate extends SingleOfferTemplate{
    constructor(props = {}) {
        super(props)
    }

    initComponents() {
        if(!this.container){
            this.container = new Webview()
        }
        console.log('init player; ', this.campaign, this.unit, this)
        // H5 Video组件初始化 - START
        this.playerView = document.createElement('mtg-video');
        this.playerView.init(opts);
        this.playerView.render();
        
        // 相关事件绑定
        this.playerView.eventConnect(
            'click',
            this.playerView.barEl.getAllBts().find((it) => it.name == 'Play').instance,
            () => {
                this.playerView.videoEl.play();
                this.playerView.getAllLayouts()[2].hide();
            },
        );
        this.playerView.eventConnect(
            'click',
            this.playerView.barEl.getAllBts().find((it) => it.name == 'Stop').instance,
            () => {
                this.playerView.videoEl.pause();
                this.playerView.getAllLayouts()[2].show();
            },
        );
        // H5 Video组件初始化 - END
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.playerView && this.playerView.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return super._isLoadFinish()
    }
}

export default H5VideoTemplate